import { useEffect, useRef } from 'react';
import { registerStudyGuard, releaseStudyGuard, isStudyDirty } from './studyGuard';

/* Declares "this exercise has unsaved progress right now".

   `dirty` is read through a ref so the guard always sees the latest value
   without re-registering on every answer — re-registering would churn the
   token and risk releasing the wrong one.

   Also wires beforeunload, which covers the other way a session vanishes:
   closing the tab or hitting reload. */
export default function useStudyGuard(dirty) {
  const dirtyRef = useRef(dirty);
  dirtyRef.current = dirty;

  useEffect(() => {
    const token = registerStudyGuard(() => dirtyRef.current);

    const onBeforeUnload = event => {
      if (!isStudyDirty()) return undefined;
      event.preventDefault();
      event.returnValue = '';   // required by Chrome to show its own prompt
      return '';
    };
    window.addEventListener('beforeunload', onBeforeUnload);

    return () => {
      releaseStudyGuard(token);
      window.removeEventListener('beforeunload', onBeforeUnload);
    };
  }, []);
}
